import * as constants from './constants';
import {get} from "../../../utils/request";
import {ORDER_CONSUME} from '../../../utils/api';

export const SpaceList = (Entity) => ({
    type: constants.SPACE_LIST,
    value: Entity
});

export const getSpaceList = (params) => {
    return (dispatch) => {
        return get(ORDER_CONSUME, params)
            .then((response) => {
                return dispatch(SpaceList(response.data));
            });
    }
};

